import { render, staticRenderFns } from "./ContainerPage.vue?vue&type=template&id=4edc847a"
import script from "./ContainerPage.vue?vue&type=script&lang=js"
export * from "./ContainerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports